const FontSizes = {
  nineXLarge: '14rem', // 140px   1 usages
  eightXLarge: '12rem', // 120px  3 usages
  sevenXLarge: '9.6rem', // 96px  7 usages
  sixHalfXLarge: '8rem', // 80px  2 usages
  sixXLarge: '6.4rem', // 64px    4 usages
  fiveXLarge: '5rem', // 50px     9 usages
  fourXLarge: '4rem', // 40px     8 usages
  xxxLarge: '3.6rem', // 36px     1 usages
  xxLarge: '3.2rem', // 32px      1 usages
  xLarge: '2.8rem', // 28px       2 usages
  large: '2.4rem', // 24px        4 usages
  xMedium: '2.1rem', // 21px      9 usages
  lMedium: '1.9rem', // 19px      9 usages
  medium: '1.8rem', // 18px       17 usages
  normal: '1.6rem', // 16px       21 usages
  small: '1.4rem', // 14px        20 usages
  xSmall: '1.2rem', // 12px       6 usages
  xxSmall: '1rem', // 10px        0 usages
} as const;

export default FontSizes;
